export default __webpack_public_path__ + "static/media/arrow-up.326eedc4.svg";